import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import { Sessao } from "../CaixaPage";
import BoxComponent from "../../../components/Box/BoxComponent";
import TypographyComponent from "../../../components/Typography/ThypographyComponent";
import { formatDate } from "../../../utils/datas";
import { formatNumberToDinheiro } from "../../../utils/dinheiro";

interface ModalListaSessoesProps {
    open: boolean;
    title: string;
    onClickSessao: (id: number) => void;
    onClose: () => void;
    sessoes: Sessao[]
}

const ModalListaSessoesComponent = (props: ModalListaSessoesProps) => {
    return <Dialog open={props.open} onClose={props.onClose} maxWidth={false} sx={{
        display: "flex",
        justifyContent: "center",
        height: "100dvh",
        width: "100vw",
        "& .MuiDialog-container": {
            "& .MuiPaper-root": {
                width: "384px",
            },
        },
    }} fullWidth>
        <DialogTitle
            sx={{
                fontFamily: '"Font 7", sans-serif',
                fontWeight: 600,
                fontSize: '18px',
                lineHeight: '28px',
                letterSpacing: '0em',
                color: '#333333',
                display: 'inline-flex',
                alignItems: 'center',
                verticalAlign: 'middle',
                textTransform: 'none'
            }}
        >
            {props.title}
        </DialogTitle>

        <DialogContent>
            <BoxComponent component="section" sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.5
            }}>
                {props.sessoes.map((element: Sessao, index: number) => {
                    return <ButtonComponent
                        id={`sessao-${element.id}`}
                        key={`sessao-${element.id}`}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: 'flex-start',
                            height: '62px',
                            boxSizing: 'border-box',
                            borderRadius: '8px',
                            border: '1px solid #E0E0E0',
                            padding: '12px',
                            backgroundColor: '#FFFFFF',
                            cursor: 'pointer',
                            opacity: 1,
                            // Transição instantânea conforme especificado
                            transition: 'none',
                            '&:active': {
                                backgroundColor: '#F5F5F5', // Feedback visual simples de clique
                            },
                            // Estilo do texto interno (seguindo Font 7)
                            fontFamily: '"Font 7", sans-serif',
                            fontSize: '14px',
                            color: '#333333'
                        }}
                        onClick={() => props.onClickSessao(element.id)}
                    >
                        <TypographyComponent
                            variant="body1"
                            sx={{
                                fontFamily: '"Font 7", sans-serif',
                                fontWeight: 600,
                                fontSize: '14px',
                                lineHeight: '20px',
                                letterSpacing: '0em',
                                color: '#333333',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle',
                                textTransform: 'none'
                            }}
                        >
                            Sessão {element.id}
                        </TypographyComponent>
                        <TypographyComponent
                            variant="body2"
                            sx={{
                                fontFamily: '"Font 7", sans-serif',
                                fontWeight: 400,
                                fontSize: '12px',
                                lineHeight: '16px',
                                letterSpacing: '0em',
                                color: '#666666',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle',
                                textTransform: 'none'
                            }}
                        >
                            {formatDate(element.abertoEm)} - {element.status} - {formatNumberToDinheiro(element.valor)}
                        </TypographyComponent>
                    </ButtonComponent>
                })}
            </BoxComponent>
        </DialogContent>

        <DialogActions sx={{
            display: "flex",
            justifyContent: "center"
        }}>
            <ButtonComponent
                id="close_modal_sessoes" onClick={props.onClose}
                sx={{
                    height: '42px',
                    display: 'flex',
                    alignItems: 'center',
                    boxSizing: 'border-box',
                    borderRadius: '8px',
                    border: '1px solid #E0E0E0',
                    padding: '8px 16px', // Conforme sua especificação (top/bottom e right/left)
                    opacity: 1,
                    backgroundColor: '#FFFFFF',
                    // Estilos de texto baseados nos padrões que definimos antes
                    fontFamily: '"Font 7", sans-serif',
                    fontSize: '14px',
                    color: '#333333',
                    textTransform: "initial",
                    width: "100%"
                }}
            >
                Fechar
            </ButtonComponent>
        </DialogActions>
    </Dialog >
}

export default ModalListaSessoesComponent;